import React from 'react';
import {Datagrid, List, TextField} from 'react-admin';

export const CardList = props => (
    <List   {...props} exporter={false}>
        <Datagrid rowClick={false}>
            <TextField source="id"/>
            <TextField source="cardUid"/>
        </Datagrid>
    </List>
);

export default CardList
